var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.92857 0 0 .92857-681.94-139.37)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 28,
    cy: 184.55,
    cx: 768.86,
    fill: "#197ff1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m770.54 199.45q-.776.817-1.961.817-1.185 0-2-.817-.776-.817-.776-1.961 0-1.144.776-1.961.817-.817 2-.817 1.185 0 1.961.817.817.817.817 1.961 0 1.144-.817 1.961m-.041-8.499h-3.841v-1.92q0-1.839.776-3.146.776-1.348 2.738-3.146 1.103-1.021 1.553-1.512.49-.531.94-1.43.49-.94.49-1.92 0-1.88-1.226-3.02-1.185-1.144-3.31-1.144-3.514 0-4.821 3.922l-3.514-1.471q.858-2.329 2.942-4.168 2.125-1.88 5.393-1.88 3.718 0 6.05 2.206 2.329 2.166 2.329 5.557 0 1.471-.776 2.983-.776 1.512-1.389 2.166-.572.613-1.634 1.594-.123.123-.204.204-2.492 2.247-2.492 4.494v1.634",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.7aa14763065eb2b442b8f05f2c8421eb.svg";
export { ForwardRef as ReactComponent };